import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ReminderDataInterface } from 'src/app/models/reminder-data.interface';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormFocusDirective } from '../../../core/directives/form-focus.directive';

@Component({
    selector: 'app-reminder-action-default-data',
    templateUrl: './reminder-action-default-data.component.html',
    styleUrls: ['./reminder-action-default-data.component.scss'],
    imports: [FormsModule, FormFocusDirective, ReactiveFormsModule, MatFormFieldModule, MatInputModule]
})
export class ReminderActionDefaultDataComponent implements ReminderDataInterface, OnInit {
    public _data: string;

    set data(value: string) {
        this._data = value;
        this.fillForm();
    }

    get data(): string {
        this.fillData();
        return this._data;
    }

    public dataForm: UntypedFormGroup;

    constructor() {}

    ngOnInit(): void {
        this.dataForm = new UntypedFormGroup({
            data: new UntypedFormControl({ value: '' }, [Validators.required]),
        });

        this.fillForm();
    }

    private fillForm() {
        if (this.dataForm) {
            if (this._data) {
                this.dataForm.get('data').setValue(this._data);
            } else {
                this.dataForm.get('data').setValue('{}');
            }
        }
    }

    private fillData() {
        this._data = this.dataForm.get('data').value;
    }

    public isValid(): boolean {
        return this.dataForm?.valid;
    }
}
